var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22451 5.8302C2.46745 5.52896 2.9086 5.48169 3.20985 5.72463L10.4507 11.564C10.752 11.807 10.7992 12.2481 10.5563 12.5494C10.3133 12.8506 9.87219 12.8979 9.57095 12.655L2.33008 6.81555C2.02884 6.5726 1.98157 6.13145 2.22451 5.8302Z",
    fill: "#8D33FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8649 6.93872C15.2758 4.506 12.1865 9.49346 12.1865 9.49346C12.1865 9.49346 9.05389 4.506 5.4648 6.93872C2.28892 9.08407 4.51636 14.8549 12.1432 19.3503C19.8133 14.8549 22.0407 9.12344 18.8649 6.93872Z",
    fill: "#FF8833"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0331 12.8397C12.2749 12.5375 12.7158 12.4885 13.018 12.7302L17.6895 16.4675C17.9917 16.7092 18.0407 17.1502 17.799 17.4524C17.5572 17.7546 17.1163 17.8036 16.8141 17.5618L12.1425 13.8246C11.8403 13.5828 11.7913 13.1419 12.0331 12.8397Z",
    fill: "#8D33FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70761 7.7546L1.22568 5.34551C1.1628 5.0312 1.42792 4.74838 1.74563 4.79084L4.1808 5.11627C4.55742 5.16661 4.71961 5.62158 4.45974 5.8988L2.50651 7.98245C2.24665 8.25966 1.78215 8.12718 1.70761 7.7546Z",
    fill: "#8D33FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8502 18.7067V16.0803L18.186 17.866V19.7967C18.186 20.1854 17.7389 20.4041 17.432 20.1654L16.0306 19.0754C15.9168 18.9869 15.8502 18.8508 15.8502 18.7067Z",
    fill: "#8D33FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3861 15.5552L15.8502 16.0793L18.1664 17.955L19.8973 17.5973C20.278 17.5186 20.4016 17.0365 20.1058 16.7843L18.7837 15.6572C18.674 15.5637 18.5273 15.5261 18.3861 15.5552Z",
    fill: "#8D33FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.450324f1844ed1e34caf557b751bf48f.svg";
export { ForwardRef as ReactComponent };